import { Link } from "react-router-dom";
import { ALL_SERVICES, THEME } from "@/data/site";

const pages = [
  { to: "/", title: "Home · होम" },
  { to: "/eye-care", title: "Eye Care · नेत्र सेवाएँ" },
  { to: "/surgery", title: "Surgery · सर्जरी" },
  { to: "/doctors", title: "Doctors · डॉक्टर" },
  { to: "/contact", title: "Contact · संपर्क" },
];

export default function Sitemap() {
  return (
    <section className="container-x min-h-[60vh] py-12 sm:py-16" data-testid="sitemap-page">
      <p className="eyebrow text-maroon">Medicity Hospital · Ballia</p>
      <h1 className="font-display mt-2 text-3xl text-ink sm:text-4xl">Website Sitemap <span className="font-en text-xl text-muted2">· साइटमैप</span></h1>
      <div className="mt-8 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        <section>
          <h2 className="font-display text-xl text-ink">मुख्य पेज</h2>
          <ul className="mt-3 space-y-2">
            {pages.map((page) => <li key={page.to}><Link className="text-maroon underline-offset-4 hover:underline" to={page.to}>{page.title}</Link></li>)}
          </ul>
        </section>
        {(["eye", "surgery"]).map((dept) => (
          <section key={dept}>
            <h2 className="font-display text-xl text-ink">{THEME[dept].labelHi} <span className="font-en text-sm text-muted2">· {THEME[dept].labelEn}</span></h2>
            <ul className="mt-3 space-y-2">
              {ALL_SERVICES.filter((service) => service.dept === dept).map((service) => (
                <li key={service.slug}><Link className="text-maroon underline-offset-4 hover:underline" to={`/services/${service.slug}`}>{service.titleHi}</Link></li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </section>
  );
}
